import { autoinject, customAttribute } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

@autoinject
@customAttribute('af-movable')
export class MovableCustomAttribute {
  private movable: HTMLElement;
  @bindable({ primaryProperty: true }) trigger: Element;

  constructor(element: Element) {
    this.movable = element as HTMLElement;
  }

  attached() {
    const updatePosition = () => {
      const rect = this.movable.getBoundingClientRect();
      this.movable.style.position = 'absolute';
      this.movable.style.left = rect.left + "px";
      this.movable.style.top = rect.top + "px";
    }

    window.setTimeout(updatePosition, 0);
  }

  triggerChanged(newValue: Element, oldValue: Element) {
    if (oldValue) this.disableTrigger(oldValue);
    if (newValue) this.enableTrigger(newValue);
  }

  enableTrigger(trigger: Element) {
    trigger.addEventListener("mousedown", this.downListener);
  }

  disableTrigger(trigger: Element) {
    trigger.removeEventListener("mousedown", this.downListener);
  }

  private downListener = (downEvent: MouseEvent) => {
    let x = downEvent.clientX;
    let y = downEvent.clientY;

    const moveListener = (moveEvent: MouseEvent) => {
      this.movable.style.left = (this.movable.offsetLeft - x + moveEvent.clientX) + "px"; x = moveEvent.clientX;
      this.movable.style.top = (this.movable.offsetTop - y + moveEvent.clientY) + "px"; y = moveEvent.clientY;
    }

    const upListener = (upEvent: MouseEvent) => {
      document.removeEventListener("mouseup", upListener);
      document.removeEventListener("mousemove", moveListener);
    }

    document.addEventListener("mouseup", upListener);
    document.addEventListener("mousemove", moveListener);
  }
}
